// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606020836/js/" + chunkId + "." + {"44":"ccc88232","225":"bc567e83","481":"6d825fe3","486":"7065eb67","770":"656923ca"}[chunkId] + ".0.017580617484184935.chunk.js";
};